'use strict';

export function DateUtil($filter, moment) {
  const OneDayInMSec = 24 * 60 * 60 * 1000;
  const OneHourInMSec = 60 * 60 * 1000;
  const OneMinuteInMSec = 60 * 1000;
  const ServerTimeZoneOffset = 9 * OneHourInMSec;

  function beginningOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function leapDate(baseDate, elapsedDate) {
    return new Date(baseDate.valueOf() + elapsedDate * OneDayInMSec);
  }

  function leapMonth(baseDate, elapsedMonth) {
    let tmp = angular.copy(baseDate);
    return new Date(tmp.setMonth(tmp.getMonth() + elapsedMonth));
  }

  function jstToUTC(date_string) {
    return (Date.parse(date_string) + ServerTimeZoneOffset);
  }

  function localToJST(date) {
    let utc = date.valueOf() + (new Date().getTimezoneOffset() * OneMinuteInMSec);
    return new Date(utc + ServerTimeZoneOffset);
  }

  function getDemandRange(date) {
    let demand_start_time = null;
    if (date.getMinutes() < 30) {
      demand_start_time = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), 0, 0);
    } else {
      demand_start_time = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), 30, 0);
    }
    let demand_end_time = new Date(demand_start_time.valueOf() + (30 * OneMinuteInMSec));

    return [demand_start_time, demand_end_time];
  }

  function getBillingDate(date, billingDate) {
    const numberOfDay = date.clone().endOf('month').date();

    if (billingDate > numberOfDay) {
      return date.clone().endOf('month').startOf('date');
    } else {
      return date.clone().date(billingDate);
    }
  }

  return {
    isToday: (date) => {
      let now = localToJST(new Date());
      return beginningOfDay(date).valueOf() === beginningOfDay(now).valueOf();
    },
    isOldest: (date) => {
      let now = localToJST(new Date());
      return ((now - date) / OneDayInMSec) >= 99;
    },
    getDateString: (date) => {
      return ('0' + (date.getMonth() + 1)).slice(-2) + '月' + ('0' + date.getDate()).slice(-2) + '日';
    },
    getDateDomain: (date) => {
      let today = beginningOfDay(date);
      let tomorrow = beginningOfDay(leapDate(date, 1));
      return [today.valueOf(), tomorrow.valueOf()];
    },
    getBillingDateDomain: (date, billingDate) => {
      if (billingDate === 0) {
        billingDate = 1;
      }

      let target = moment(date).startOf('day');
      let start, end;

      if (date.getDate() >= billingDate) {
        start = getBillingDate(target, billingDate);
      } else {
        start = getBillingDate(target.clone().subtract(1, 'months'), billingDate);
      }

      if (date.getDate() >= billingDate) {
        end = getBillingDate(target.clone().add(1, 'months'), billingDate).subtract(1, 'days');
      } else {
        end = getBillingDate(target, billingDate).subtract(1, 'days');
      }

      return [start.toDate(), end.toDate()];
    },
    getDateTicks: (date, interval) => {
      if (angular.isUndefined(interval) || interval === 0) {
        interval = 1;
      }
      let today = beginningOfDay(date);
      let tickValue = [];
      for (let i = 0; i < (24 / interval); i++) {
        tickValue.push(today.valueOf() + OneHourInMSec * i * interval);
      }
      return tickValue;
    },
    getXLabels: ["00:30", "01:00", "01:30", "02:00", "02:30", "03:00", "03:30", "04:00", "04:30", "05:00", "05:30", "06:00", "06:30", "07:00", "07:30", "08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00", "20:30", "21:00", "21:30", "22:00", "22:30", "23:00", "23:30", "00:00"],
    getQueryParams: (date) => {
      return {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate()
      };
    },
    getActivePowerQueries: (date) => {
      // 当日 00:00 から 翌日 00:00 までのデータを取得するためのクエリパラメータ
      let start_time = new Date(beginningOfDay(date));
      let end_time = new Date(beginningOfDay(leapDate(date, 1)));
      return {
        start_y: start_time.getFullYear(),
        start_m: start_time.getMonth() + 1,
        start_d: start_time.getDate(),
        start_hour: 0, start_min: 0,
        end_y: end_time.getFullYear(),
        end_m: end_time.getMonth() + 1,
        end_d: end_time.getDate(),
        end_hour: 0, end_min: 0
      };
    },
    getDateRangeQueries: (startDate, endDate) => {
      const start = moment(startDate);
      const end = moment(endDate);

      return {
        start_y: start.year(),
        start_m: start.month() + 1,
        start_d: start.date(),
        end_y: end.year(),
        end_m: end.month() + 1,
        end_d: end.date(),
      }
    },
    datetimeRangeQuery: (startDate, endDate) => {
      return {
        start_y: startDate.year(),
        start_m: startDate.month() + 1,
        start_d: startDate.date(),
        start_hour: 0,
        start_min: 30,
        end_y: endDate.year(),
        end_m: endDate.month() + 1,
        end_d: endDate.date(),
        end_hour: 0,
        end_min: 0
      }
    },
    getDemandRange: getDemandRange,
    getDemandTitle: (date) => {
      let [start_time, end_time] = getDemandRange(date);
      return `${$filter('date')(start_time, 'yyyy年MM月dd日 HH:mm ~')} ${$filter('date')(end_time, 'HH:mm')}`;
    },
    jstToLocal: (date_string) => {
      let utc = jstToUTC(date_string);
      return (utc + (new Date().getTimezoneOffset() * OneMinuteInMSec));
    },
    localToUTC: (date) => {
      return (date.valueOf() - (new Date().getTimezoneOffset() * OneMinuteInMSec));
    },
    jstToUTC: jstToUTC,
    localToJST: localToJST,
    leapDate: leapDate,
    /**
     * サーバーから渡された JST の日付文字列を UTC へ変換し、日付を elapsedDate 日ずらす。
     * 瞬時積算有効電力量グラフで、前日分のデータを当日分のグラフに重ねるために使用する。
     */
    leapJstDate: (date_string, elapsedDate) => {
      let utc = jstToUTC(date_string);
      return leapDate(utc, elapsedDate).valueOf();
    },
    leapMonth: leapMonth,
    beginningOfDay: beginningOfDay,
    beginningOfWeek: (date) => {
      let baseDate = beginningOfDay(date);
      return leapDate(baseDate, -1 * baseDate.getDay());
    },
    beginningOfMonth: date => {
      let baseDate = beginningOfDay(date);
      return new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
    }
  };
}



// WEBPACK FOOTER //
// ./public/dev/components/logic/date_util/date_util.js